/*global unescape: false, escape: false, ob_set: false,
	WS: false, ActiveXObject: false, geoplugin_countryCode: false */
/** section: Whitespace
* class WS.StorageControl
* Tracking control class. Used for only running non-essential storage based tasks.
*
* This class should be instanced before use.
**/
(function() {
	// create WS namespace
	if (typeof window.WS === "undefined") {
		window.WS = {};
	}

	// create ob_set
	if (typeof window.ob_set === "undefined") {
		window.ob_set = function(ob, defaults) {
			// set default object properties
			var key;

			for (key in defaults) {
				if (defaults.hasOwnProperty(key)) {
					if (defaults[key] !== null && defaults[key].constructor === Object &&
						(ob[key] === undefined || ob[key].constructor === Object)) {
						// traverse nested objects
						ob[key] = window.ob_set(ob[key] || {}, defaults[key]);
					} else if (ob[key] === undefined) {
						// replace missing objects
						ob[key] = defaults[key];
					}
				}
			}

			return ob;
		};
	}

	// create a very stripped down version of WS.Storage (cookie only)
	if (typeof window.WS.Storage === "undefined") {
		window.WS.Storage = (function() {
			var my = {
				'cookie': {
					getItem: function(key) {
						return unescape(
							document.cookie.replace(
								new RegExp("(?:^|.*;\\s*)" + escape(key).replace(/[\-\.\+\*]/g, "\\$&") +
									"\\=((?:[^;](?!;))*[^;]?)(?:;.*)?|.*"),
								"$1"
							)
						) || null;
					},

					setItem: function(key, val, expires, path) {
						var cookie;

						cookie = escape(key) + "=" + escape(val);

						if (typeof expires === "string") {
							cookie += "; expires=" + expires;
						}

						cookie += "; path=" + (path || "/");

						document.cookie = cookie;
					},

					removeItem: function(key) {
						var a, b, domains, paths, path_parts, domain_parts;

						if (!key) {
							return;
						}

						domains = [""];
						paths = [""];

						domain_parts = location.hostname.split(".");
						path_parts = location.pathname.replace(/^\/(.*?)\/$/, "$1").split("/");

						// create a list of domains
						for (a = domain_parts.length - 2; a >= 0; a -= 1) {
							domains.push(
								((a > 0) ? "." : "") +
								domain_parts.slice(a, (domain_parts.length)).join(".")
							);
						}

						// create a list of paths
						for (a = 0; a <= path_parts.length; a += 1) {
							paths.push(
								"/" +
								path_parts.slice(0, a).join("/")
							);
						}

						// clear without path/domain data
						document.cookie = escape(key) + "=; expires=Thu, 01 Jan 1970 00:00:00 GMT;";

						if (my.cookie.getItem(key) !== null) {
							// clear with specific path/domain data
							_out:

							for (a = 0; a < domains.length; a += 1) {
								for (b = 0; b < paths.length; b += 1) {
									document.cookie = escape(key) + "=;" +
										" expires=Thu, 01 Jan 1970 00:00:00 GMT;" +
										((domains[a] !== "") ? " domain=" + domains[a] + ";" : "") +
										((paths[b] !== "") ? " path=" + paths[b] : "");

									if (my.cookie.getItem(key) === null) {
										break _out;
									}
								}
							}
						}
					}
				}
			};

			return {
				get: function(key, default_val) {
					var data, val, date, expiry_date;

					if (default_val === undefined) {
						default_val = null;
					}

					data = null;

					// attempt cookie retrieval
					data = my.cookie.getItem(key);

					try {
						try {
							if ((data = $.parseJSON(data))) {
								// json parsing succeeded
								if (typeof data !== "object") {
									// value is not an object
									data = {
										'val': (data.toString() || null)
									};
								}
							}
						} catch(e) {
							// JSON conversion failed - create object from value
							data = {
								'val': (data.toString() || null)
							};
						}

						if (data !== null && data.val !== null) {
							// test expiry
							if (data.expires) {
								date = new Date();
								expiry_date = new Date(data.expires);

								if (date >= expiry_date) {
									// data has expired - set null and remove
									data = null;
									this.clear(key);
								} else {
									data = data.val;
								}
							} else {
								data = data.val;
							}
						}
					} catch(e) {
						data = null;
					}

					if (data === null) {
						// set as default
						val = default_val;
					} else {
						val = data;
					}

					return val;
				},

				set: function(key, data, expires, path, storage) {
					var method, expiry_date;

					path = path || "/";

					if (!key) {
						throw new Error("A valid key is required for setting a storage item.");
					}

					data = {
						'val': data
					};

					// set expiry as 365 days
					expiry_date = new Date();
					expiry_date.setTime(expiry_date.getTime() + (365 * 24 * 60 * 60 * 1000));

					if (!expiry_date.toUTCString) {
						throw new Error("Expiry date " + expires + " is in invalid format.");
					}

					if (data.val.length > 4000) {
						throw new Error("A maximum length of 4000 characters is allowed for using cookie-based storage.");
					}

					my.cookie.setItem(key, JSON.stringify(data), expiry_date.toUTCString(), path);
				},

				clear: function(key) {
					my.cookie.removeItem(key);
				}
			};
		}());
	}

	window.WS.StorageControl = (function(options) {
		/**
		* new WS.StorageControl([options])
		* - options (Object): Optional options key/value pairs.
		*
		* Create a new instance of StorageControl.
		*
		* Once the class is instantiated, the [[WS.StorageControl#run]] method can be used to either immediately
		* run or queue your own functions for use after local storage methods are accepted.
		*
		* #### Available options.
		* The `options` argument is a key/value pair of specific settings which customise the way
		* StorageControl works. The following options can be set:
		*
		* * `callbacks` (`Object`): Callback options
		*   * `ready` (`Function`): Run when the interface is displayed and ready.
		*   * `init` (`Function`): Run when the class is initialized.
		*   * `revoke` (`Function`): Run when storage acceptance is revoked.
		* * `persist` (`Boolean`; default `true`): Set `true` to persist the anchor on screen even after acceptance.
		* * `optin` (`Boolean`; default `true`): Set `true` to enable opt-in behaivour, `false` to enable implicit
		*   acceptance behaivour.
		* * `revokable` (`Boolean`; default `true`): Set `true` to allow revoking of acceptance.
		* * `context` (`Element`; default `document.body`): Root DOM element which will contain the interface.
		* * `text` (`Object`): Text strings:
		*   * `heading` (`String`): Main heading.
		*   * `intro` (`String`): Short introduction.
		*   * `full` (`String`): Full explanation, which is hidden by default.
		*   * `readmore` (`String`): 'Read more' link.
		*   * `accept` (`String`): 'Accept' link
		* * `styles` (`Object`): Style options for the following elements:
		*   * `dialog` (`Object`): CSS key/value pairs for the main dialog
		*   * `anchor` (`Object`): CSS key/value pairs for the anchor button
		**/
		var my, cls;

		cls = {
			/**
			* WS.StorageControl#show(show[, callback]) -> undefined
			* - show (Boolean): `true` to show the dialog, `false` to hide it.
			* - callback (Function): Callback to run after dialog is altered.
			*
			* Shows or hides the popup dialog, optionally running a callback after the effect has finished.
			**/
			show: function() {
				return my.show.apply(this, arguments);
			},

			/**
			* WS.StorageControl#run(fn, args) -> undefined
			* - fn (Function): Function to run.
			* - args (Array): Argument values to send to the function when run.
			*
			* This method will do one of two things depending on the current state:
			*
			* * If local storage is accepted, `fn` will run immediately with the specified `args` arguments.
			* * If local storage is not yet accepted or the status is otherwise unknown, `fn` will be entered
			*   into a queue for running once local storage is accepted.
			**/
			run: function(fn, args) {
				// queue function
				if (my.status.allowed) {
					fn.apply(window, args || []);
				} else {
					my.queue.push([fn, args]);
				}
			}
		};

		my = {
			enable: function() {
				my.elements = {};
				my.queue = [];

				my.classes = {
					'allowed': 'allowed',
					'ie6': 'ua-ie6',
					'content': 'content',
					'intro': 'intro text',
					'full': 'full text',
					'heading': 'heading',
					'button': 'button',
					'buttons': {
						'readmore': 'readmore',
						'accept': 'accept',
						'revoke': 'revoke',
						'close': 'close'
					}
				};

				// set options
				options = ob_set(options || {}, {
					'callbacks': {
						'ready': null,
						'init': null,
						'revoke': null
					},
					'optin': true,
					'countries': [],
					'persist': true,
					'revokable': true,
					'context': $(document.body),
					'text': {
						'heading': 'Cookies',
						'intro': 'This site uses cookies to store information on your computer.',
						'full': null,
						'readmore': 'Read more...',
						'accept': 'I accept',
						'revoke': 'Revoke permission'
					},
					'styles': {}
				});

				// if optin is false, permission is implied
				if (options.optin === false && WS.Storage.get("ws-cookies-allowed") === null) {
					WS.Storage.set("ws-cookies-allowed", true, false);
				}

				// get stored data
				my.status = {
					'visible': false,
					'allowed': WS.Storage.get("ws-cookies-allowed", false),
					'dnt': (typeof navigator.doNotTrack !== "undefined" &&
						(navigator.doNotTrack === "yes" || navigator.doNotTrack === "1")),
					'shown': WS.Storage.get("ws-cookies-shown", false),
					'ie6': (/msie|MSIE 6/.test(navigator.userAgent) && window.XMLHttpRequest === undefined && ActiveXObject !== undefined),
					'country_applied': true
				};

				// set options - full text
				if (options.optin === true && options.text.full === null ||
					(options.optin === false && my.status.allowed === false)) {
					options.text.full = 'Some of these cookies are essential to make our site work and have already been set. Others help us to improve by giving us some insight into how the site is being used or help to improve the experience of using our site but will only be set if you consent.';
				} else {
					options.text.full = 'Cookies are used on this site. If you continue browsing it implies you are happy with our use of cookies.';
				}

				// expose internal variables
				cls.status = my.status;

				// get country data
				if (typeof geoplugin_countryCode === "function" && options.countries.length > 0) {
					(function() {
						var country;

						country = geoplugin_countryCode();

						if (typeof country === "string") {
							// country is set - check against data
							if (options.countries.indexOf(country) !== -1) {
								// exists in list - set applied state
								my.status.country_applied = true;
							} else {
								// does not exist in list - allow storage
								my.status.country_applied = false;
								my.status.allowed = true;
							}
						}
					}());
				} else {
					my.status.country_applied = true;
				}

				// run init callback
				if (typeof options.callbacks.init === "function") {
					options.callbacks.init.apply(cls, [my.status.allowed, my.status.dnt]);
				}

				// create interface
				if ((!my.status.dnt || (my.status.dnt && (my.status.allowed && options.persist))) &&
					(!my.status.allowed || (my.status.allowed && options.persist)) &&
					(my.status.country_applied)) {
					my.create();
				}

				my.set_state(my.status.allowed);
			},

			create: function() {
				// create dialog
				if (!my.elements.dialog) {
					my.elements.dialog = $('<div>', {
						'id':'ws-storagecontrol'
					}).css({
						'position': 'fixed',
						'visibility': 'hidden',
						'left': '40px',
						'bottom': '40px'
					}).append([
						$('<div>', {
							'class': my.classes.content
						}).append([
							$('<div>', {
								'class': my.classes.intro
							}).append([
								$('<h2>', {
									'class': my.classes.heading
								}).text(options.text.heading),
								$('<p>').text(options.text.intro)
							]),
							$('<p>', {
								'class': my.classes.button
							}).append(
								$('<a>', {
									'href': '#',
									'class': my.classes.buttons.readmore
								}).text(options.text.readmore)
							),
							$('<div>', {
								'class': my.classes.full
							}).append(
								$('<p>').text(options.text.full)
							),
							$('<p>', {
								'class': my.classes.button
							}).append(
								$('<a>', {
									'href': '#',
									'class': my.classes.buttons.accept
								}).text(options.text.accept)
							),
							$('<p>', {
								'class': my.classes.button
							}).append(
								$('<a>', {
									'href': '#',
									'class': my.classes.buttons.revoke
								}).text(options.text.revoke).hide()
							)
						]),
						$('<a>', {
							'href': '#',
							'title': 'Close',
							'class': my.classes.buttons.close
						})
					]).appendTo(options.context);

					my.elements.dialog = $('#ws-storagecontrol');
					my.elements.readmore_button = $('a.' + my.classes.buttons.readmore);
					my.elements.full_desc = $('div.' + my.classes.full.replace(/\ /g, '.'));
					my.elements.accept_button = $('a.' + my.classes.buttons.accept);
					my.elements.revoke_button = $('a.' + my.classes.buttons.revoke);
					my.elements.close_button = $('a.' + my.classes.buttons.close);

					// store full description metrics and hide
					my.elements.full_desc.attr("height", my.elements.full_desc.height()).css({
						'overflow': 'hidden',
						'height': 0
					});

					my.elements.dialog.hide().css({
						'visibility': 'visible'
					});
				}

				// create anchor
				if (!my.elements.anchor) {
					$('<a>', {
						'id': 'ws-storagecontrol-anchor',
						'href': '#'
					}).css(ob_set(options.styles.anchor || {}, {
						'position': 'fixed',
						'left': 0,
						'bottom': 0
					})).appendTo(options.context);
					my.elements.anchor = $('#ws-storagecontrol-anchor');
				}

				// fix display for ie6
				if (my.status.ie6) {
					if (my.elements.dialog.css("position") === "fixed") {
						my.elements.dialog.css({
							'position': 'absolute',
							'left': options.styles.dialog.left || options.styles.dialog.right || 0 + 'px',
							'top': options.styles.dialog.top || options.styles.dialog.bottom || 0 + 'px',
							'right': null,
							'bottom': null
						}).addClass(my.classes.ie6);
					}

					if (my.elements.anchor.css("position") === "fixed") {
						my.elements.anchor.css({
							'position': 'absolute',
							'left': 0,
							'top': 0
						}).addClass(my.classes.ie6);
					}
				}

				// observe
				my.elements.dialog.bind("click", my.handle_event);
				my.elements.anchor.bind("click", my.handle_event);

				// display popup and run ready callback
				if (!my.status.shown && !my.status.allowed) {
					// display popup automatically
					my.show(true, function() {
						WS.Storage.set("ws-cookies-shown", true);

						if (typeof options.callbacks.ready === "function") {
							options.callbacks.ready.apply(cls, [my.elements.dialog]);
						}
					});
				} else {
					if (typeof options.callbacks.ready === "function") {
						options.callbacks.ready.apply(cls, [my.elements.dialog]);
					}
				}
			},

			handle_event: function(event) {
				// handle the various applied events
				var element;

				if (event.type === "click") {
					element = event.target;

					if (element === my.elements.accept_button[0]) {
						event.preventDefault();
						my.set_state(true, event);
					} else if (element === my.elements.revoke_button[0]) {
						event.preventDefault();
						my.set_state(false, event);
					} else if (element === my.elements.anchor[0]) {
						// re-show dialog
						event.preventDefault();
						my.show(true);
					} else if (element === my.elements.close_button[0]) {
						// close dialog
						event.preventDefault();
						my.show(false);
					} else if (element === my.elements.readmore_button[0]) {
						event.preventDefault();

						if (my.elements.full_desc.css("height") !== "0px") {
							// close
							if (typeof $ !== "undefined" && typeof $.fn.animate !== "undefined") {
								my.elements.full_desc.animate({
									'height': '0'
								});
							} else {
								my.elements.full_desc.css({
									'height': '0'
								});
							}
						} else {
							// open
							if (typeof $ !== "undefined" && typeof $.fn.animate !== "undefined") {
								my.elements.full_desc.animate({
									'height': my.elements.full_desc.attr('height')
								});
							} else {
								my.elements.full_desc.css({
									'height': 'auto'
								});
							}
						}
					}
				}
			},

			set_state: function(allowed, event) {
				// set state of the acceptance
				var is_event;

				is_event = (typeof event !== "undefined");

				if (allowed) {
					// save acceptance
					WS.Storage.set("ws-cookies-allowed", true, false);

					// parse queue
					my.run_queue();

					if (my.elements.anchor && my.elements.dialog) {
						// set classes to accepted
						my.elements.anchor.addClass(my.classes.allowed);

						// set revoke state
						if (options.revokable) {
							my.elements.dialog.addClass(my.classes.allowed);

							my.elements.accept_button.hide();
							my.elements.revoke_button.show();
						}

						// remove dialog (permanently if required)
						if (is_event) {
							my.show(false, function() {
								if (!options.persist) {
									my.elements.dialog.remove();
									my.elements.anchor.remove();
								}
							});
						}
					}
				} else {
					// remove acceptance
					WS.Storage.set("ws-cookies-allowed", false, false);

					if (my.elements.anchor && my.elements.dialog) {
						// remove acceptance classes
						my.elements.anchor.removeClass(my.classes.allowed);

						// set revoke state
						if (options.revokable) {
							my.elements.dialog.removeClass(my.classes.allowed);

							my.elements.accept_button.show();
							my.elements.revoke_button.hide();
						}

						if (is_event) {
							my.show(false);
						}
					}

					// run revoke callback (only if run as event)
					if (is_event && typeof options.callbacks.revoke === "function") {
						options.callbacks.revoke();
					}
				}
			},

			show: function(show, callback) {
				// show/hide popup and run callback.
				if ((show && my.status.visible) ||
					(!show && !my.status.visible)) {
					return false;
				}

				if (typeof $ !== "undefined" && typeof $.fn.animate !== "undefined") {
					if (show) {
						my.elements.dialog.fadeIn('slow', callback);
					} else {
						my.elements.dialog.fadeOut('slow', callback);
					}

					my.status.visible = show;
				} else {
					if (show) {
						my.elements.dialog.show();
					} else {
						my.elements.dialog.hide();
					}

					if (typeof callback === "function") {
						callback();
					}

					my.status.visible = show;
				}
			},

			run_queue: function() {
				var a, args;

				if (my.queue.length > 0) {
					// run all queued callbacks
					for (a = 0; a < my.queue.length; a += 1) {
						if (typeof my.queue[a][0] === "function") {
							my.queue[a][0].apply(window, my.queue[a][1] || []);
						}
					}

					// clear queue
					my.queue = [];
				}
			}
		};

		my.enable();

		return cls;
	});
}());